import React from 'react';
import fr from 'facet-rest';
import {
  FDBox, FDContentContainer, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { ClickableTextRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ClickableTextRel';
import { metaOverrideSet } from './metaOverrideSet';

export const PM2JourneyScheduleMeetingLaterPageLayout = () => {
  const { resource } = useMetaLayoutContext();
  const components = resource.attr('components').resources().list();
  return (
    <FDContentContainer maxWidth="lg">
      <FDStack direction="row" justifyContent="space-between" spacing={8} alignItems={'center'}>
        <FDStack direction={'column'} spacing={3} width="50%">
          <MetaControlField attr={'title'} />
          {components.map((component) => (
            <FDStack direction="row" alignItems="center" spacing={2} key={component.id()}>
              <FDIcon icon={component.attr('icon')} size="md" />
              <MetaControl resource={component} attrName="name" metaOverrideSet={metaOverrideSet} />
            </FDStack>
          ))}
          <ClickableTextRel appearance="standalone" relationship={resource.relationship(fr.relationships.bookNow.name)} />
        </FDStack>
        {resource.withRelationship(fr.relationships.image.name, (rel) => {
          return (
            <FDPaper padding={4} width={'65%'}>
              <FDBox paddingY={3}>
                <ImageRel relationship={rel} />
              </FDBox>
            </FDPaper>
          );
        }, () => null)}
      </FDStack>
    </FDContentContainer>
  );
};
